export default __webpack_public_path__ + "static/2-0f07c8460d627013c62c98e0bbc154fa.jpg";